type Options = {
    dataSelector: string;
    summaryHiddenSelector: string;
}

const defaultOptions: Options = {
    dataSelector: '.composite_data',
    summaryHiddenSelector: '.widget_composite_summary.summary_widget_hidden',
}

class Composite {
    constructor(private readonly el: HTMLElement, private options: Options = defaultOptions) {
        this.el = el;
        this.options = {
            ...defaultOptions,
            ...options,
        };

        this.init();
    }

    public init(): void {
        // @ts-ignore
        if(typeof jQuery === 'undefined') {
            return;
        }

        const data = document.querySelector(this.options.dataSelector);
        if (!data) {
            return;
        }

        // @ts-ignore
        jQuery(document).on('wc-composite-initializing', data, function (event: Event, composite: any) {
            composite.actions.add_action('component_selection_changed', this.onChange.bind(this), 100, this);
            composite.actions.add_action('component_selection_content_changed', this.onChange.bind(this), 100, this);
            composite.actions.add_action('active_step_transition_end', this.onVisibilityChange.bind(this), 100, this);
        }.bind(this));
    }

    private async onChange(): Promise<void> {
        this.el.dispatchEvent(new Event('change'));
    }

    private async onVisibilityChange(): Promise<void> {
        if (this.el.querySelector(this.options.summaryHiddenSelector)) {
            this.el.dispatchEvent(new Event('disable'));
        } else {
            this.el.dispatchEvent(new Event('enable'));
        }
    }
}

export default Composite;
